import React from "react";
import { useApp } from "@/apps/launcher/context/AppContext";

export interface ProfilePromoItemProps {
  element: any;
  onClick?: (element: any) => void;
  onDoubleClick?: (element: any) => void;
}

export const WebviewPromoItem = function(props: ProfilePromoItemProps){
  const element: any = props.element;
  const appContext = useApp();

  return (
    <div className="promo-element webview">
      <iframe src={element.url} title={element.title || 'Promo'} />
    </div>
  );

}
